<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white border border-gray-400 hover:border-gray-500">
      <dropdown :auto-close="false" class="py-3 px-4 md:px-6 border-r hover:bg-gray-100 focus:border-white focus:shadow-outline focus:z-10" placement="bottom-start">
        <div class="flex items-baseline">
          <span class="text-gray-700 inline">{{$t('shared.search_filter.filter')}}</span>
          <svg class="w-2 h-2 fill-gray-700 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 961.243 599.998">
            <path d="M239.998 239.999L0 0h961.243L721.246 240c-131.999 132-240.28 240-240.624 239.999-.345-.001-108.625-108.001-240.624-240z" />
          </svg>
        </div>
        <div slot="dropdown" class="mt-2 px-3 py-3 w-screen shadow-xl bg-white" :style="{ maxWidth: `${maxWidth}px` }">
          <slot />
        </div>
      </dropdown>
    </div>
    <button class="ml-3 text-sm" type="button" @click="$emit('reset')">{{$t('shared.search_filter.reset')}}</button>
  </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
  },
  props: {
    value: String,
    maxWidth: {
      type: Number,
      default: 400,
    },
  },
}
</script>
